import { useState, useEffect } from "react";
import { useProfileData } from "../Hooks/UserHooks";

const CalculateRemainingDays = () => {
  const { profileData } = useProfileData();
  const [remainingDays, setRemainingDays] = useState(null);

  useEffect(() => {
      if (profileData?.subscriptionEndDate && profileData?.subscriptionStartDate) {
        const endDate = new Date(profileData.subscriptionEndDate);
        const startDate = new Date(profileData.subscriptionStartDate);
        const currentDate = new Date();

        const totalDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
        const remainingDays = Math.ceil((endDate - currentDate) / (1000 * 60 * 60 * 24));
        setRemainingDays(remainingDays > 0 ? remainingDays : 0);

        const interval = setInterval(() => {
          const newCurrentDate = new Date();
          const newRemainingDays = Math.ceil((endDate - newCurrentDate) / (1000 * 60 * 60 * 24));
          setRemainingDays(newRemainingDays > 0 ? newRemainingDays : 0);
        }, 1000 * 60 * 60 * 24); // Update every 24 hours

        return () => clearInterval(interval); // Cleanup on unmount
      } else {
        setRemainingDays(null);
      }
  }, [profileData]);

  return remainingDays;
};

export default CalculateRemainingDays;
